import { render, staticRenderFns } from "./EnvelopesCheckList.vue?vue&type=template&id=3ab86c5f&scoped=true"
import script from "./EnvelopesCheckList.vue?vue&type=script&lang=js"
export * from "./EnvelopesCheckList.vue?vue&type=script&lang=js"
import style0 from "./EnvelopesCheckList.vue?vue&type=style&index=0&id=3ab86c5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab86c5f",
  null
  
)

export default component.exports